export default __webpack_public_path__ + "static/media/NSECHSDEC(Medical,SurgicalandGynaeUnit)SDECguidanceforambulanceclinicians.aaa3671d.jpg";